export default __webpack_public_path__ + "static/media/Horne FL 3.53a0b12e.JPEG";